import { EventActionType } from './event-action-type';

export interface SetEventPageIdAction {
  eventKey: string;
  pageId: string;
  type: EventActionType.SetEventPageId;
}

export const setEventPageId = (
  eventKey: string,
  pageId: string,
): SetEventPageIdAction => ({
  eventKey,
  pageId,
  type: EventActionType.SetEventPageId,
});
